import { render, staticRenderFns } from "./m-edit-wall-time-dialog.vue?vue&type=template&id=33823e5a&scoped=true&"
import script from "./m-edit-wall-time-dialog.vue?vue&type=script&lang=js&"
export * from "./m-edit-wall-time-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33823e5a",
  null
  
)

export default component.exports